const queryString = require('query-string');

import React from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, Alert, NavbarBrand } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { serverUrl } from 'Config';
import Footer from '@components/Footer';

class PasswordForgotten extends React.Component {
    constructor(props) {
        super(props);

        const parsed = queryString.parse(this.props.location.search);
        this.token = parsed.token;

        this.state = {
            data: {
                password: '',
                password2: ''
            },
            validationError: ''
        }

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    resetAlerts() {
        this.setState({ validationError: '' });
    }

    onChange(e) {
        const trg = e.target;

        this.setState(prevState => {
            prevState.data[trg.name] = trg.value;
            prevState.validationError = '';
            return prevState;
        });
    }

    validate() {
        let isValid = this.state.data.password === this.state.data.password2;

        if (!this.state.data.password.length) {
            this.setState(prevState => pevState.validationError = 'Field is required');
            isValid = false;
        }
        else {
            if (!isValid) {
                this.setState(prevState => prevState.validationError = 'Passwords don\'t match');
            }
        }
        return isValid;
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.validate()) {
            axios({
                method: 'POST',
                url: serverUrl + '/password-forgotten',
                data: { ...this.state.data }
            })
                .then(resp => toast.success('Password has been changed'))
                .catch(e => toast.error('Error occurred while changing password'));
        }
    }

    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header">Create Password</div>
                                <div className="card-block">
                                    <Form onSubmit={this.onSubmit}   >
                                        <FormGroup row>
                                            <Label htmlFor="password" sm={2}>Password :</Label>
                                            <Col sm={10}>
                                                <Input name="password" type="password" value={this.state.data.password} maxLength="255" onChange={this.onChange} />
                                                {this.state.validationError.length > 0 &&
                                                    <div className="font-weight-bold" style={{ fontSize: '0.7rem', color: '#c00' }}>{this.state.validationError}</div>
                                                }
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label htmlFor="password2" sm={2}>Confirm Password :</Label>
                                            <Col sm={10}>
                                                <Input name="password2" type="password" value={this.state.data.password2} maxLength="255" onChange={this.onChange} />
                                            </Col>
                                        </FormGroup>
                                        <hr />
                                        <FormGroup row>
                                            <Col>
                                                <Link to="/login">
                                                    <button className="btn btn-secondary-new">Cancel</button>
                                                </Link>
                                            </Col>
                                            <Col className="text-right">
                                                <button
                                                    type="submit"
                                                    className="float-right btn btn-primary-new"
                                                    disabled={!this.state.data.password.length}
                                                >Send</button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}

export default PasswordForgotten;


// WEBPACK FOOTER //
// ./src/views/Pages/CreatePassword/CreatePassword.js